// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  width: var(--custom-button-width);
}
.btn.btn--rounded-default {
  border-radius: 30px;
}

/* Play button */
.play-button-block__inner {
  border-color: var(--text-color);
  gap: 10px;
}
.play-button-block__inner.no-border {
  border: none;
}
.play-button-block__inner > .play-button-block-left.right {
  order: 1;
}
.play-button-block__inner > .play-button-block-left .icon {
  color: var(--icon-color);
}
.play-button-block__inner > .play-button-block-right {
  margin-left: 0;
  color: var(--text-color);
}

/* Buy button */
.shopify-payment-button__button {
  border-radius: var(--buy-button-round-option, 0) !important;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/buttons.scss"],"names":[],"mappings":"AAAA;EAKE,iCAAA;AAHF;AADE;EACE,mBAAA;AAGJ;;AAGA,gBAAA;AACA;EACE,+BAAA;EACA,SAAA;AAAF;AAEE;EACE,YAAA;AAAJ;AAII;EACE,QAAA;AAFN;AAKI;EACE,wBAAA;AAHN;AAOE;EACE,cAAA;EACA,wBAAA;AALJ;;AASA,eAAA;AACA;EACE,2DAAA;AANF","sourcesContent":[".btn {\n  &.btn--rounded-default {\n    border-radius: 30px;\n  }\n\n  width: var(--custom-button-width);\n}\n\n/* Play button */\n.play-button-block__inner {\n  border-color: var(--text-color);\n  gap: 10px;\n\n  &.no-border {\n    border: none;\n  }\n\n  > .play-button-block-left {\n    &.right {\n      order: 1;\n    }\n\n    .icon {\n      color: var(--icon-color);\n    }\n  }\n\n  > .play-button-block-right {\n    margin-left: 0;\n    color: var(--text-color);\n  }\n}\n\n/* Buy button */\n.shopify-payment-button__button {\n  border-radius: var(--buy-button-round-option, 0) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
